// const serverUrl = 'https://jd.xingjun-group.com/index.php'; // 开发环境
export const serverUrl = 'https://xtlyadmin.xingjun-group.com'; // 开发环境
// const serverUrl = ''; // 生产环境
export const api = {
  // ---- 免登录接口 start ----
  // 没有登录查询房间
  getRoomListNoLogin: serverUrl + '/index/Member/web_api_room',
  // 匿名提交订单
  bookRoomNoLogin: serverUrl + '/index/Member/web_lock_order',
  // 订单信息发邮件
  orderEmail: serverUrl + '/index/Member/order_email_end',
  // 获取酒店基本信息
  getMotelInfo: serverUrl + '/index/Member/get_base',
  // 可兑换优惠券查询，酒店中的可供用户积分兑换的优惠券
  getRedeemableCouponList: serverUrl + '/index/Member/coupon_get',
  // 活动查询
  getActivityList: serverUrl + '/index/Member/activity_list',
  // 查询邮箱是否注册，并返回该邮箱名下的积分
  isRegistered: serverUrl + '/index/Member/web_m_u',

  // 用户注册
  // register: serverUrl + '/index/Member/register',
  register: serverUrl + '/api/login/register',
  // 用户登录
  // login: serverUrl + '/index/Member/login_api',
  login: serverUrl + '/api/login/login',
  // ---- 免登录接口 end ----

  // ---- 需登录后才能访问接口 start ----
  // 获取用户信息
  me: serverUrl + '/index/Member/m_user_date',
  // 查询房间(已登录)
  getRoomList: serverUrl + '/index/Member/api_room',
  // 提交订单接口
  bookRoom: serverUrl + '/index/Member/lock_order',
  // 订单查询接口
  // getOrderList: serverUrl + '/index/Member/order_query',
  // 单个订单查询接口
  getOrder: serverUrl + '/index/Member/get_order',
  // 修改密码
  changePassword: serverUrl + '/index/Member/up_password',
  // 在线支付接口
  onlinePay: serverUrl + '/index/payment/wechat_Pay_api',
  // 可使用优惠券查询
  getAvailableCouponList: serverUrl + '/index/Member/transaction',
  // 积分兑换优惠券
  redeemCoupon: serverUrl + '/index/Member/exchange',
  // 查询常住人数据
  getGuestList: serverUrl + '/index/Member/check_in_name_query',
  // 编辑常住人数据
  editGuest: serverUrl + '/index/Member/check_in_name_modify',
  // 新增常住人数据
  addGuest: serverUrl + '/index/Member/check_in_name_add',
  // 删除常住人
  deleteGuest: serverUrl + '/index/Member/check_in_name_delete',
  // 建议与意见提交接口
  feedback: serverUrl + '/index/Member/feedback',
  //获取订单列表
  getOrderList: serverUrl + '/api/order/list',
  //获取车型
  getCarType: serverUrl + '/api/car/list',
  //提交预定订单
  submitReservation: serverUrl + '/api/order/reserve',
  //获取预定订单
  getReservationInfo: serverUrl + '/api/order/info',
  //取消预定订单
  cancelReservation: serverUrl + '/api/order/cancel',
  //支付订单
  payReservation: serverUrl + '/api/order/pay',
  //联系我们
  contactUs: serverUrl + '/api/contact_us/add',
  //获取轮播图列表
  getBannerList: serverUrl + '/api/banner/list',
  // ---- 需登录后才能访问接口 end ----
};
